import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../features/auth/services/auth.service';
import { ModulesService } from './module.service';
import { PermissionService } from './permission.service';
import { ModulePermissionResponse } from '../models/permission.model';
import { environment } from '../../../environments/environment';

export function initializePermissions(): () => Promise<void> {
  const permissionService = inject(PermissionService);
  const modulesService = inject(ModulesService);
  const authService = inject(AuthService);
  const http = inject(HttpClient);

  return async () => {
    if (!authService.isAuthenticated()) {
      return;
    }

    try {
      const response = await firstValueFrom(
        http.get<ModulePermissionResponse>(`${environment.apiUrl}/api/Me/GetMyModulePermissions`)
      );

      if (response?.data) {
        permissionService.setPermissions(response.data.permissions ?? []);
        modulesService.setNavigationModules(response.data.modules ?? []);
      }
    } catch (error) {
      console.error('APP_INITIALIZER: Failed to load permissions', error);
    }
  };
}
